module.exports = __webpack_public_path__ + "public/img/defen.26d1854e.png";